import queryString from "query-string"
import { cacheApiResponse } from "./api-cache"
import { WINDOW } from "../constants/environment"

const getRequestURL = (endpoint, params) => `${endpoint}?${queryString.stringify(params)}`

export async function fetchStockData({
  nameplate, locationId, dealerCode, outletStockEndpoint
} = {}) {
  try {
    if (!nameplate && !dealerCode) { throw new Error("A nameplate or dealercode is required to fetch stock") }
    if (!(dealerCode && locationId)) { throw new Error("DealerCode should be used in combination with location locationId") }
    if (nameplate && !dealerCode) { throw new Error("Nameplate results without dealer is not supported") }
    if (!outletStockEndpoint) throw new Error("Cannot fetch without endpoint")

    let checksum = 0

    const getRequestedNameplateData = data =>
      data.find(savedNameplate => savedNameplate.nameplate === nameplate)

    const invalidateCache = ({ data }) => () => {
      if (!nameplate) return true // If the query is for all stock always invalidate the cache
      const { lastModified, count } = getRequestedNameplateData(data)
      return checksum !== checksumGen({ lastModified, count })
    }

    const cacheKey = cacheKeyGen({ dealerCode, id: locationId }, nameplate)

    const cache = WINDOW.localStorage && WINDOW.localStorage.getItem(cacheKey)

    if (cache && nameplate) {
      const { data } = JSON.parse(cache)
      const { lastModified, count } = getRequestedNameplateData(data)
      checksum = checksumGen({ lastModified, count })
    }
    const url = getRequestURL(outletStockEndpoint, {
      nameplate,
      locationId,
      dealerCode,
      checksum
    })
    const data = await fetchFromApi(url)

    const { response } = await cacheApiResponse(cacheKey, () => data, invalidateCache(data))
    return { response }
  } catch (error) {
    console.warn("OUTLET FETCH", error)
    return { error }
  }
}

async function fetchFromApi(url) {
  const response = await fetch(url, { method: "GET" })
  if (response.status !== 200) throw new Error(`Failed with status ${response.status}`)
  return response.json()
}

const checksumGen = ({ lastModified, count }) => {
  if (lastModified && count) return String(lastModified) + String(count)
  return 0
}

export const cacheKeyGen = (dealer, nameplate) =>
  `${nameplate || 0}_${dealer.dealerCode || 0}_${dealer.id || 0}`.replace(/-|\s/g, "")



// WEBPACK FOOTER //
// ./src/apis/outlet.js